import { createSlice } from '@reduxjs/toolkit';
import { isEmpty as _isEmpty } from 'lodash-es';

const initialState = {
  selectedFilter: {},
  isPopOverOpened: false,
  isRadioPopOverOpened: false,
  ManageImageStoreFilter: {},
  dashboard:{
  },
  isFilterValueChanged:false,
  lastSelectedDashboard:''
};

export const channelFilterSlice = createSlice({
  name: 'channelFilter',
  initialState,
  reducers: {
    setChannelFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
    setChannelFilterPopOver: (state, action) => {
      state.isPopOverOpened = action.payload;
    },
    setRadioChannelFilterPopOver: (state, action) => {
      state.isRadioPopOverOpened = action.payload;
    },
    setManageImageStoreFilter: (state, action) => {
      state.ManageImageStoreFilter = action.payload;
    },
    setChannelFilterForCustomDashboard: (state, action) => {
      state.dashboard[action.payload.key] = action.payload.value;
    },
    setLastSelectedDashboard: (state, action) => {
      state.lastSelectedDashboard = action.payload
    },
    setIsFilterValueChanged: (state, action) => {
      state.isFilterValueChanged = action.payload;
    }
  }
});

export const { setChannelFilter, setChannelFilterPopOver, setRadioChannelFilterPopOver, setManageImageStoreFilter, setChannelFilterForCustomDashboard,
  setLastSelectedDashboard,
  setIsFilterValueChanged,
  
 } =
  channelFilterSlice.actions;

export default channelFilterSlice.reducer;
